export { Widget } from './Widget';
export type { WidgetProps } from './Widget';
